export type StandaloneLegalSlug =
  | "user-agreement"
  | "privacy"
  | "compliance";

export const STANDALONE_LEGAL_TITLES: Record<StandaloneLegalSlug, string> = {
  "user-agreement": "Tactik 用户协议",
  privacy: "Tactik 隐私政策",
  compliance: "Tactik 法律合规",
};

/** 独立站法规正文（占位，后续可接 CMS 或静态 HTML） */
export const STANDALONE_LEGAL_BODY: Record<StandaloneLegalSlug, string> = {
  "user-agreement": "Tactik 用户协议正文待补充。",
  privacy: "Tactik 隐私政策正文待补充。",
  compliance: "Tactik 法律合规正文待补充。",
};

export function isStandaloneLegalSlug(
  slug: string
): slug is StandaloneLegalSlug {
  return slug in STANDALONE_LEGAL_TITLES;
}
